import { Component, ViewChild } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../../../globals';
import { OdsServices } from '../../../../services';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { CompCreateDishPage } from '../../../../../components/popups/create-dish/create-dish';
/**
 * Generated class for the OdsConfigMenuCreateSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ods-config-menu-create-select',
    templateUrl: 'ods-config-menu-create-select.html',
})
export class OdsConfigMenuCreateSelectPage {
    //datatable
    sorts = [
        { prop: 'name', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        private toastCtrl: ToastController,
        public translate: TranslateService,
        public modalCtrl: ModalController,
        public odsServices: OdsServices) {
        this.getElements();
    }

    async getElements() {
        await this.odsServices.getElements(0);
    }

    clickElement(event) {
        if (event.type == 'click') {
            if (event.row.type === 'menu') {
                event.row.type = 'combo';
                //Esto se hace, porque los combos tienen que estar activdos para que en el takeaway funcionen correctamente y dentro del combo no se pueden activar
                if (event.row.tk_active === undefined || event.row.tk_active == false) {
                    this.odsServices.afs.collection('menus').doc(event.row.UID).update({
                        tk_active: true
                    });
                }
            }
            if (this.odsServices.selected_elements.findIndex(x => (x.UID || x.uid) === event.row.UID) === -1) {
                this.odsServices.selected_elements.push(event.row);
                let toast = this.toastCtrl.create({
                    message: this.translate.instant('general-articulo') + ' ' + this.globals.nameLangSelectProduct(event.row) + ' ' + this.translate.instant('instant-anadido-correctemente'),
                    duration: 3000,
                    position: 'bottom'
                });
                toast.present();
            } else {
                let toast = this.toastCtrl.create({
                    message: this.translate.instant('instant-elemento-anadido-lista'),
                    duration: 3000,
                    position: 'bottom'
                });
                toast.present();
            }
        }
    }

    createDish() {
        //open create dish
        let profileModal = this.modalCtrl.create(CompCreateDishPage, {
            origin: 'ods'
        });
        profileModal.present();
    }
}


// WEBPACK FOOTER //
// ./src/pages/ods/ods-config/ods-config-menu/ods-config-menu-create/ods-config-menu-create-select/ods-config-menu-create-select.ts